import { I18n } from "../services/I18n";
import "./generated/site-translations-sl";
import common_sl from "../../../../../libs/ps/restaumatic-common/locales/sl.json";
import core_types_sites_sl from "../../../../../libs/ps/restaumatic-core-types-sites/locales/sl.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  sl: { _core_types_sites: core_types_sites_sl },
});
I18n.translations = I18n.extend(I18n.translations, {
  sl: { _common: common_sl },
});
